var isArguments = {};
export {
  isArguments as __exports
};
//# sourceMappingURL=isArguments.js.map
